import { render, staticRenderFns } from "./teesheet.vue?vue&type=template&id=b70630a8"
import script from "./teesheet.vue?vue&type=script&lang=js"
export * from "./teesheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports